import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e2878bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Mitarbeiter:in")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Projekt")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Notizen")
], -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = {
  key: 1,
  class: "row entwicklungsplan-outer"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", null, "- Es wurden noch keine Projektzusammenarbeiten hinterlegt -")
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.zusammenarbeiten && _ctx.zusammenarbeiten.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zusammenarbeiten, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row mt-2 justify-items-start zusammenarbeit",
        key: item.userid + item.text
      }, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(item.userid), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(item.text), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(item.note), 1)
      ]))
    }), 128)),
    (!_ctx.zusammenarbeiten || _ctx.zusammenarbeiten.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true)
  ], 64))
}